import PropTypes from 'prop-types';
import AceEditor from 'react-ace';
import { useTheme } from 'styled-components';

// styled
import {
  InputRow, MainContainer, VarTip,
} from './styled/SqlQueryModal.styled';

const SqlQueryModal = ({
  query,
}) => {
  const theme = useTheme();
  return (
    <MainContainer>
      <VarTip>
        Este é um modelo de declaração SQL utilizada para a geração do conjunto de dados utilizado
        para a criação deste template. Você pode gerar um arquivo utilizando este código e, então,
        aplicar este template sobre este arquivo.
      </VarTip>
      <span style={{
        color: theme.inputLabel,
        fontSize: '0.85rem',
        fontWeight: 'bold',
        marginBottom: '0.5rem',
      }}
      >
        Código SQL (opcional)
      </span>
      <InputRow style={{ height: '100%' }}>
        <AceEditor
          mode="sql"
          theme="monokai"
          fontSize={14}
          lineHeight={19}
          scrollMargin={[0, 0]}
          enableLiveAutocompletion
          enableBasicAutocompletion
          enableSnippets
          tabSize={4}
          showPrintMargin
          showGutter
          highlightActiveLine
          readOnly
          value={query}
          style={{ width: '100%', height: '100%', borderRadius: '8px' }}
          name="CodeEditor"
          editorProps={{ $blockScrolling: true }}
          placeholder="SELECT ... FROM ... WHERE ..."
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            enableMobileMenu: true,
            showLineNumbers: true,
          }}
        />
      </InputRow>
    </MainContainer>
  );
};

SqlQueryModal.propTypes = {
  /**
   * query to be displayed and copied.
  * */
  query: PropTypes.string.isRequired,
};

export default SqlQueryModal;
